import React from 'react'
import { redirect, RouteObject } from 'react-router-dom'

import { Layout } from '../layouts'
import routePath from './routePath'
import { NotFound } from '../views/NotFound'

export const exceptionRoutes = {
  element: <Layout variant="exception" />,
  children: [
    {
      id: 'notFound404Route',
      path: routePath.notFound404,
      element: <NotFound />,
    },
    {
      // has to be last route
      id: 'notFoundRedirectRoute',
      path: routePath.notFoundRedirect,
      loader: () => redirect(routePath.notFound404),
    },
  ],
} as const satisfies RouteObject
